import { INVITE_DOCTOR_FORM_KEY } from './constants';

export const inviteDoctorFormSelector = state => {
    return state[INVITE_DOCTOR_FORM_KEY] || {};
};
